import { render, staticRenderFns } from "./PaidCustodyActive.vue?vue&type=template&id=2cc22e0c&scoped=true"
import script from "./PaidCustodyActive.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaidCustodyActive.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PaidCustodyActive.vue?vue&type=style&index=0&id=2cc22e0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc22e0c",
  null
  
)

export default component.exports